import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DialogBaseComponent } from '../../common/dialog/dialog-base/dialog-base.component';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { ReportsMenuNavigationService } from 'src/app/services/UI/reports-menu-navigation.service';
import { PopupOptions } from 'src/app/common/helpers/menulist/popup-options';
import { PopupOpenMode, ViewReportMode } from 'src/app/common/enums/enums';
import { environment } from 'src/environments/environment';
import { AiCookieService } from 'src/app/services/AIReports/ai-cookie.service';

@Component({
  selector: 'app-reports-menu',
  templateUrl: './reports-menu.component.html',
  styleUrls: ['./reports-menu.component.scss'],
  standalone: false,
})
export class ReportsMenuComponent extends DialogBaseComponent implements OnInit {
  isAiReportsEnabled = environment.IS_AI_REPORTS_ENABLED;

  ViewReportMode = ViewReportMode;
  viewMode: ViewReportMode = ViewReportMode.All;
  public data: any;

  private readonly reportsMenuNavigation = inject(ReportsMenuNavigationService);
  private readonly destroyRef = inject(DestroyRef);

  constructor(private ds: DialogService, private ref1: ChangeDetectorRef,) {
    super(ds, ref1);
  }

  ngOnInit(): void {
    this.getViewMode();
    let options = PopupOptions.options.find(t => t.mode == this.data.mode) || PopupOptions.options[0];
    this.data.options = options;
    this.data.options.primaryTabName = (this.data.mode == PopupOpenMode.List) ? "lbl_all_reports" : "lbl_published_reports";

    // Vipps top-up return flow (app.component.ts) opens this dialog with autoOpenAiChat
    // set so the user lands straight on the AI Reports > Chat tab instead of "All reports".
    // Uses changeViewMode() rather than presetting data.viewMode directly, since
    // ViewReportMode.All and the unrelated PopupViewMode.GalleryView both equal 1 and
    // this.data.viewMode is reused ambiguously between the two enums.
    // Guarded by isAiReportsEnabled: the template only renders the Ai pane when that flag
    // is also true (see reports-menu.component.html), so forcing viewMode=Ai while it's off
    // would render a blank dialog with no tab active — fall back to the default All-reports.
    if (this.data.autoOpenAiChat && this.isAiReportsEnabled) {
      this.changeViewMode(ViewReportMode.Ai);
    }

    // Nested components in the Ai tab cannot reference this dialog directly — they request tab switches through the service.
    this.reportsMenuNavigation.viewModeRequested$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(mode => this.changeViewMode(mode));
  }

  getViewMode(): number {
    return this.data.viewMode;
  }

  changeViewMode(mode: ViewReportMode): void {
    this.data.viewMode = mode;
    this.data.reference = { Id: 0, rawData: "" }
    if (mode == ViewReportMode.All) {
      this.data.options.primaryTabName = "lbl_all_reports";
    } else if (mode == ViewReportMode.Ai) {
      this.data.options.primaryTabName = "lbl_ai_reports";
    } else if (mode == ViewReportMode.Published) {
      this.data.options.primaryTabName = "lbl_published_reports";
    }
  }
}
